import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MeasureService} from '../shared/measure.service';
import {MainMapService} from '../../../../shared/service/main-map.service';

@Component({
    selector: 'measure-toolbox',
    templateUrl: './measure-toolbox.component.html',
    styleUrls: ['measure-toolbox.component.scss'],
    standalone: false
})
export class MeasureToolboxComponent implements OnInit, OnDestroy {
  @Input('activeWidget') activeWidget: __esri.DistanceMeasurement2D | __esri.AreaMeasurement2D;
  @Input('measureNumber') measureNumber: number;

  @ViewChild('measureRef', { static: true }) measureRef: ElementRef;
  @ViewChild('measureToolboxComponentRef', { static: true }) measureToolboxComponentRef: ElementRef;
  private mapView: __esri.MapView;

  constructor(
    private _measureService: MeasureService,
    private _mainMapService: MainMapService) {}

  ngOnInit() {
    this.mapView = this._mainMapService.mapView;
    this._measureService.createMeasureWidget(
      this.mapView,
      this.activeWidget,
      this.measureRef
    );
  }

  /**
   * @description clears up the active measure from map & removes the active measure-toolbox from the widget.
   */
  public leaveComponent() {
    this.removeWidget();
    this.measureToolboxComponentRef.nativeElement.remove();
  }

  /**
   * @description remove the active measure-toolbox from the widget.
   */
  private removeWidget() {
    if (this.activeWidget) {
      this.mapView.ui.remove(this.activeWidget);
      this.activeWidget.destroy();
      this.activeWidget = null;
    }
  }

  /**
   * @description clean up, when component gets destroyed
   */
  ngOnDestroy(): void {
    this.removeWidget();
  }
}
